import { TrackerMetadataState } from 'types/trackerMetadata';

const InitialTrackerMetadataState: Partial<TrackerMetadataState> = {};

export default InitialTrackerMetadataState;
